import URL from '@/creditflowresearch/Router/urlConstants';
import { ABS_PRODUCT_ID, HYC_PRODUCT_ID, IGC_PRODUCT_ID } from '@/creditflowresearch/domain/Product/constants';

export const MarketOverviewByProductId = {
  [ABS_PRODUCT_ID]: URL.MARKET_OVERVIEW_ALL,
  [HYC_PRODUCT_ID]: URL.MARKET_OVERVIEW_HYC,
  [IGC_PRODUCT_ID]: URL.MARKET_OVERVIEW_IGC,
} as const;
